module.exports = __webpack_public_path__ + "static/img/5.94a34710.jpg";